import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Menu, X, PhoneCall } from 'lucide-react';
import { websiteData } from '../data/websiteData.js';

export default function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // Monitor scroll for header styling adjustments
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Map links to routes
  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'About Us', path: '/about' },
    { name: 'Contact Us', path: '/contact' }
  ];

  return (
    <header className="header" style={{
      boxShadow: isScrolled ? '0 10px 30px -10px rgba(11, 31, 51, 0.15)' : 'none',
      borderBottom: '1px solid rgba(0, 0, 0, 0.08)'
    }}>
      <div className="container">
        <nav className="navbar-container" aria-label="Main Navigation">
          {/* Logo Link to Home */}
          <Link 
            to="/" 
            className="nav-logo-link" 
            onClick={() => setIsMobileMenuOpen(false)}
            aria-label="Vijay Industry Home"
          >
            <img 
              src="/logo.png" 
              alt="Vijay Industry" 
              style={{ height: '60px', objectFit: 'contain', display: 'block' }} 
            />
          </Link>

          {/* Desktop Navigation Links */}
          <div className="nav-links">
            {navLinks.map((link) => (
              <NavLink
                key={link.path}
                to={link.path}
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              >
                {link.name}
              </NavLink>
            ))}
          </div>

          {/* Desktop Get a Quote CTA Button */}
          <div className="navbar-cta">
            <Link 
              to="/contact" 
              className="btn btn-primary"
              style={{ fontSize: '0.9rem', padding: '0.6rem 1.25rem' }}
            >
              Get a Quote
            </Link>
          </div>

          {/* Mobile Menu Toggle Button */}
          <button
            className="mobile-menu-btn"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-expanded={isMobileMenuOpen}
            aria-label={isMobileMenuOpen ? "Close mobile menu" : "Open mobile menu"}
          >
            {isMobileMenuOpen ? <X size={26} /> : <Menu size={26} />}
          </button>
        </nav>
      </div>

      {/* Mobile Navigation Panel */}
      <div className={`mobile-nav-menu ${isMobileMenuOpen ? 'open' : ''}`}>
        <div className="mobile-nav-links">
          {navLinks.map((link) => (
            <NavLink
              key={link.path}
              to={link.path}
              className={({ isActive }) => `mobile-nav-link ${isActive ? 'active' : ''}`}
              onClick={() => setIsMobileMenuOpen(false)}
              style={{ display: 'block' }}
            >
              {link.name}
            </NavLink>
          ))}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          <Link
            to="/contact"
            className="btn btn-primary btn-block"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Get a Quote
          </Link>
          <a
            href={`tel:${websiteData.contact.phone}`}
            className="btn btn-secondary btn-block"
            style={{ 
              borderColor: 'var(--accent)', 
              color: 'var(--accent)',
              backgroundColor: 'transparent'
            }}
          >
            <PhoneCall size={16} /> Call: {websiteData.contact.phoneDisplay}
          </a>
        </div>
      </div>
    </header>
  );
}
